import type { ReactNode } from 'react';
import { useState } from 'react';

import { VrsCallCaptionsRegion } from '../VrsCallCaptionsRegion';

import { useAppSelector } from 'features/app/hooks';
import { useCaptionDisplayConfig } from 'features/call/call-captions/hooks';
import {
  selectCallCaptionLines,
  selectShouldShowCaptionsRegion,
} from 'features/call/call-captions/store';
import styled from 'features/theme/styled';

interface VrsCallCaptionsMediaLayoutProps {
  video: ReactNode;
}

export const VrsCallCaptionsMediaLayout = ({
  video,
}: VrsCallCaptionsMediaLayoutProps) => {
  const captionDisplayConfig = useCaptionDisplayConfig();
  const captionLines = useAppSelector(selectCallCaptionLines);
  const [pruneHoldRequested, setPruneHoldRequested] = useState(false);

  const holdRegionOpen = pruneHoldRequested && captionLines.length === 0;

  const shouldShowCaptionsRegion = useAppSelector((state) =>
    selectShouldShowCaptionsRegion(state, holdRegionOpen)
  );

  const hasVisibleCaptionsRegion = Boolean(
    captionDisplayConfig.enabled && shouldShowCaptionsRegion
  );

  return (
    <>
      <VideoRegion
        data-testid='vrs-call-video-region'
        $hasVisibleCaptions={hasVisibleCaptionsRegion}
      >
        {video}
      </VideoRegion>
      {hasVisibleCaptionsRegion && (
        <VrsCallCaptionsRegion
          holdRegionOpen={holdRegionOpen}
          onPrunedToEmpty={() => setPruneHoldRequested(true)}
          onRegionDismiss={() => setPruneHoldRequested(false)}
        />
      )}
    </>
  );
};

const VideoRegion = styled('div')<{ $hasVisibleCaptions: boolean }>`
  width: 100%;
  flex: ${({ $hasVisibleCaptions }) =>
    $hasVisibleCaptions ? '0 0 78%' : '1 1 100%'};
  min-height: 0;

  > * {
    width: 100%;
    height: 100%;
  }
`;
